import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import classificationService from '../../services/classification';

const initialState = {
  loading: false,
classifications: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchClassifications = createAsyncThunk(
  'classification/fetchClassifications',
  (params = {}) => {
    return classificationService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

const classificationSlice = createSlice({
  name: 'classification',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchClassifications.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchClassifications.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.classifications = payload.data;
      state.meta = payload.meta;
      state.params.page = payload.meta.current_page;
      state.params.perPage = payload.meta.per_page;
      state.error = '';
    });
    builder.addCase(fetchClassifications.rejected, (state, action) => {
      state.loading = false;
      state.classifications = [];
      state.error = action.error.message;
    });
  },
});

export default classificationSlice.reducer;
